module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/error-d4c3940735ea01cd7b3865ceb378b98f.jpg";